module.exports = __webpack_public_path__ + "img/mobile-phone.067fc869.png";